module.exports = __webpack_public_path__ + "img/donante-udci.830a6914.jpeg";